import { ProfileStatus } from "../ProfileStatusBadge/types";

export const isDocumentExpired = (expiryDate?: string | null): boolean => {
  if (!expiryDate) {
    return false;
  }

  const todayStart = new Date();
  todayStart.setHours(0, 0, 0, 0);

  const expiry = new Date(expiryDate);

  return todayStart > expiry;
};

export const getDocumentStatus = (
  hasFile: boolean,
  expiryDate?: string | null,
  uploaderInfo?: string | null,
): ProfileStatus | undefined => {
  if (!hasFile && !uploaderInfo) {
    return ProfileStatus.NotStarted;
  }

  if (isDocumentExpired(expiryDate)) {
    return ProfileStatus.UpdateRequired;
  }

  return ProfileStatus.Completed;
};
